import { render, staticRenderFns } from "./JobDetails.vue?vue&type=template&id=f9904d40&scoped=true"
import script from "./JobDetails.vue?vue&type=script&lang=js"
export * from "./JobDetails.vue?vue&type=script&lang=js"
import style0 from "./JobDetails.vue?vue&type=style&index=0&id=f9904d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9904d40",
  null
  
)

export default component.exports